import _ from 'lodash';
import { takeLatest, call, put } from 'redux-saga/effects';
import { getProjectStatusHistory } from '../../../services/projects';
import * as actions from '../projectActions';
import { errorOpenModal } from '../../_shared/modal/errorModalActions';

export default function* fetchProjectStatusHistoryWatcher() {
  yield takeLatest(actions.FETCH_STATUS_HISTORY, fetchProjectStatusHistoryWorker);
}

export function* fetchProjectStatusHistoryWorker(action) {
  yield put(actions.statusLoading(true));

  try {
    const response = yield call(getProjectStatusHistory, {
      closing_id: action.closing_id,
      limit: action.limit,
      page: action.page,
      field: action.sortField || 'Modified_Timestamp',
      direction: action.sortDirection || 'desc',
    });
    const historyData = _.get(response, 'data.projectStatusHistory', {});
    yield call(success, historyData);
  } catch (error) {
    yield call(failure, error);
  }
}

export function* success(historyData) {
  // Server-side sorting: replace existing data with sorted results
  yield put(actions.setStatusHistory(
    historyData.records || [],
    historyData.totalCount || 0
  ));
  yield put(actions.statusLoading(false));
}

export function* failure(error) {
  yield put(actions.statusLoading(false));
  yield put(actions.statusError(error));
  yield put(
    errorOpenModal({
      title: 'Status history could not be fetched',
      message: error.message,
    }),
  );
}
